export default "<div nz-row nzJustify=\"center\" nzAlign=\"middle\">\n    <p>{{confirmationText}}</p>\n</div>\n";